const backendDomin = process.env.REACT_APP_API_URL
// const backendDomin = "http://localhost:8080"
const SummaryApi = {
    signUP: {
        url: `${backendDomin}/user/signup`,
        method: "post"
    },
    signIn: {
        url: `${backendDomin}/user/signin`,
        method: "post"
    },
    allProduct: {
        url: `${backendDomin}/product/list`,
        method: 'get'
    },

    searchProduct: {
        url: `${backendDomin}/product/search`,
        method: 'get'
    },

    categoryProductBasic: {
        url: `${backendDomin}/product/category-products-basic`,
        method: "GET"
    },

    categoryProduct: {
        url: `${backendDomin}/category/categorylist`,
        method: 'get'
    },

    productDetails: {
        url: `${backendDomin}/product/view`,
        method: 'get'
    },
    /** User ratings: paths are `${productRatingBase}/:publicId/...` — publicId = 12-char product publicId */
    productRatingBase: `${backendDomin}/product`,
    addToCartProduct: {
        url: `${backendDomin}/cart/create`,
        method: 'post'
    },
    updateCartProduct: {
        url: `${backendDomin}/cart/update`,
        method: 'post'
    },
    deleteCartProduct: {
        url: `${backendDomin}/cart/delete`,
        method: 'post'
    },
    addToCartProductCount: {
        url: `${backendDomin}/cart/list`,
        method: 'get'
    },
    placeOrder: {
        url: `${backendDomin}/order/create`,
        method: 'post'
    },
    placeSingalOrder: {
        url: `${backendDomin}/order/singal/create`,
        method: 'post'
    },
    orderList: {
        url: `${backendDomin}/user/order/list`,
        method: 'get'
    },
    orderView: {
        url: `${backendDomin}/user/order/view`,
        method: 'get'
    },
    reorder: {
        url: `${backendDomin}/user/order/reorder`,
        method: 'post'
    },
    userAddress: {
        url: `${backendDomin}/address/user/view`,
        method: 'get'
    },
    addressList: {
        url: `${backendDomin}/address/user/list`,
        method: 'get'
    },
    addressCreate: {
        url: `${backendDomin}/address/user`,
        method: 'post'
    },
    addressUpdate: {
        url: (id) => `${backendDomin}/address/user/${id}`,
        method: 'put'
    },
    addressDelete: {
        url: (id) => `${backendDomin}/address/user/${id}`,
        method: 'delete'
    },
    forgotPassword: {
        url: `${backendDomin}/forgotPwdAdmin`,
        method: 'get'
    },
    resetPassword: {
        url: `${backendDomin}/resetPwdAdmin`,
        method: 'get'
    },
    contactUs: {
        url: `${backendDomin}/contact/create`,
        method: 'get'
    },
    profile: {
        url: `${backendDomin}/user/profile`,
        method: 'get'
    },
    pincode: {
        url: `${backendDomin}/pincode/list`,
        method: 'get'
    },
    profileImageUpdate: {
        url: `${backendDomin}/user/profileImage`,
        method: 'put'
    },
    profileUpdate: {
        url: `${backendDomin}/user/profileUpdateSinaglUser`,
        method: 'put'
    },
    wallet: {
        url: `${backendDomin}/wallet/view`,
        method: 'get'
    },
    walletGift: {
        url: `${backendDomin}/wallet/gift`,
        method: "post"
    },
    downloadinvoice: {
        url: `${backendDomin}/invoice`,
        method: 'get'
    },
    personalrecommendation: {
        url: `${backendDomin}/product/recommendation`,
        method: 'get'
    },
    createRefund: {
        url: `${backendDomin}/refund/request`,
        method: 'post'
    },
    cancelRefund: {
        url: `${backendDomin}/refund/cancel`,
        method: 'post'
    },
    campaignInfo: {
        url: `${backendDomin}/campaign-info`,
        method: 'get'
    },
    myRank: {
        url: `${backendDomin}/reward/my-rank`,
        method: 'get'
    },
    verifyOtp: {
        url: `${backendDomin}/auth/verify-email-otp`,
        method: 'post'
    },
    resendOtp: {
        url: `${backendDomin}/auth/resend-email-otp`,
        method: 'post'
    },
    setting: {
        url: `${backendDomin}/settings/list`,
        method: 'get'
    },
    googleLogin: {
        url: `${backendDomin}/auth/google-login`,
        method: 'get'
    },
    notificationList: {
        url: `${backendDomin}/notification/list`,
        method: 'get'
    },
    notificationUnreadCount: {
        url: `${backendDomin}/notification/unread-count`,
        method: 'get'
    },
    notificationMarkRead: {
        url: `${backendDomin}/notification`,
        method: 'put'
    },
    notificationMarkAllRead: {
        url: `${backendDomin}/notification/mark-all-read`,
        method: 'put'
    },
    notificationDelete: {
        url: `${backendDomin}/notification`,
        method: 'delete'
    },
    notificationDeleteRead: {
        url: `${backendDomin}/notification/delete-read`,
        method: 'delete'
    },
    referralMyNetwork: {
        url: `${backendDomin}/user/referral/my-network`,
        method: 'get'
    },
    referralMyEarnings: {
        url: `${backendDomin}/user/referral/my-earnings`,
        method: 'get'
    },
    walletBreakdown: {
        url: `${backendDomin}/user/wallet/breakdown`,
        method: 'get'
    },
    referralLeaderboard: {
        url: `${backendDomin}/user/referral/leaderboard`,
        method: 'get'
    },
    cancelOrder: {
        url: `${backendDomin}/user/order/cancel`,
        method: 'put'
    },
    chatSend: {
        url: `${backendDomin}/user/chat/send`,
        method: 'post'
    },
    chatConversation: {
        url: `${backendDomin}/user/chat/conversation`,
        method: 'get'
    },
    chatMarkRead: {
        url: `${backendDomin}/user/chat/mark-read`,
        method: 'put'
    },
    chatUnreadCount: {
        url: `${backendDomin}/user/chat/unread-count`,
        method: 'get'
    },
    /**
     * B2B price preview: GET /product/variant/:variantPublicId/price-preview?quantity=N
     * Returns { unitPrice, pricingMode, slabTier } for business users.
     * Usage: SummaryApi.pricePreview.url(variantPublicId) + `?quantity=${qty}`
     */
    pricePreview: {
        url: (variantPublicId) => `${backendDomin}/product/variant/${variantPublicId}/price-preview`,
        method: 'get'
    }

}


export default SummaryApi